import { useState } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/da0knle859p3u981e3t0';

type Status = { type: 'idle' | 'loading' | 'success' | 'error'; msg: string };

const initial: Status = { type: 'idle', msg: '' };

export default function ContactForm() {
  const [status, setStatus] = useState<Status>(initial);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get('website_alt') || '').trim();
    if (honeypot) {
      setStatus({ type: 'success', msg: '感谢你的留言！我们会尽快回复你。' });
      form.reset();
      return;
    }
    const name = String(fd.get('name') || '').trim();
    const email = String(fd.get('email') || '').trim();
    const message = String(fd.get('message') || '').trim();
    if (!name || !email || !message) {
      setStatus({ type: 'error', msg: '请填写完整的姓名、邮箱和留言内容。' });
      return;
    }
    setStatus({ type: 'loading', msg: '正在提交…' });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      if (res.ok && parsed?.code === 'OK') {
        setStatus({ type: 'success', msg: '留言发送成功！感谢你的支持，我们会尽快回复。' });
        form.reset();
      } else {
        setStatus({ type: 'error', msg: serverMsg || '提交失败，请稍后再试。' });
      }
    } catch {
      setStatus({ type: 'error', msg: '网络异常，请稍后再试。' });
    }
  }

  return (
    <form id="contact-form" data-readdy-form className="flex flex-col gap-4" onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="flex flex-col gap-1.5">
          <label htmlFor="cf-name" className="text-sm font-medium text-foreground-800">你的称呼</label>
          <input
            id="cf-name"
            name="name"
            type="text"
            autoComplete="name"
            placeholder="请输入称呼"
            className="rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label htmlFor="cf-email" className="text-sm font-medium text-foreground-800">电子邮箱</label>
          <input
            id="cf-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="name@example.com"
            className="rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
          />
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor="cf-topic" className="text-sm font-medium text-foreground-800">留言主题</label>
        <select
          id="cf-topic"
          name="topic"
          className="rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
        >
          <option value="合作洽谈">合作洽谈</option>
          <option value="作品投稿">作品投稿</option>
          <option value="意见建议">意见建议</option>
          <option value="问题反馈">问题反馈</option>
          <option value="其他">其他</option>
        </select>
      </div>
      <div className="flex flex-col gap-1.5">
        <label htmlFor="cf-message" className="text-sm font-medium text-foreground-800">留言内容</label>
        <textarea
          id="cf-message"
          name="message"
          rows={5}
          maxLength={500}
          placeholder="请告诉我们你的想法（最多 500 字）"
          className="resize-none rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
        ></textarea>
      </div>
      <div className="side-note-meta">
        <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>
      <button
        type="submit"
        className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-send-plane-line"></i>
        {status.type === 'loading' ? '发送中…' : '发送留言'}
      </button>
      {status.type === 'success' && <p className="text-sm text-secondary-700">{status.msg}</p>}
      {status.type === 'error' && <p className="text-sm text-primary-600">{status.msg}</p>}
    </form>
  );
}